module.exports = __webpack_public_path__ + "img/expoglitter_0824_blue.14b0d692.jpg";